import type { WorkItemPriority, WorkItemStatus, WorkItemType } from '@/api/types';

/** Presentation metadata for work-item enums. Pure — no JSX (glyphs are resolved in badges.tsx). */

export const WORK_ITEM_TYPE_LABEL: Record<WorkItemType, string> = {
  HUMAN_TASK: 'Human task',
  APPROVAL: 'Approval',
  SIGNAL_REVIEW: 'Signal review',
  RFI_FOLLOWUP: 'RFI follow-up',
};

export type Intent = 'positive' | 'attention' | 'negative' | 'neutral' | 'info' | 'processing';

export const PRIORITY_INTENT: Record<WorkItemPriority, Intent> = {
  HIGH: 'negative',
  NORMAL: 'info',
  LOW: 'neutral',
};

export const STATUS_INTENT: Record<WorkItemStatus, Intent> = {
  OPEN: 'info',
  IN_PROGRESS: 'processing',
  WAITING: 'attention',
  DONE: 'positive',
  CANCELLED: 'neutral',
};

/** CSS variable per intent (colour is always paired with an icon/text at the point of use). */
export const INTENT_VAR: Record<Intent, string> = {
  positive: 'var(--ol-positive)',
  attention: 'var(--ol-attention)',
  negative: 'var(--ol-negative)',
  info: 'var(--ol-info)',
  processing: 'var(--ol-processing)',
  neutral: 'var(--ol-text-tertiary)',
};

/** AntD Tag colour token per intent. */
export const INTENT_TAG_COLOR: Record<Intent, string> = {
  positive: 'success',
  attention: 'warning',
  negative: 'error',
  info: 'blue',
  processing: 'processing',
  neutral: 'default',
};

/** Coarse intent for a status-review disposition action (colours the disposition buttons). */
export function signalActionIntent(action: string): Intent {
  const a = action.toUpperCase();
  if (a.includes('CLEAR')) return 'positive';
  if (a.includes('ESCAL')) return 'negative';
  if (a.includes('LINK')) return 'info';
  return 'neutral';
}
